import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TenantState {
  currentTenantId: number | null;
  currentTenantSlug: string | null;
  setCurrentTenant: (id: number, slug: string) => void;
  clearCurrentTenant: () => void;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenantId: null,
      currentTenantSlug: null,
      setCurrentTenant: (id, slug) =>
        set({ currentTenantId: id, currentTenantSlug: slug }),
      clearCurrentTenant: () =>
        set({ currentTenantId: null, currentTenantSlug: null }),
    }),
    {
      name: "tenant-storage",
      // skipHydration: server renders the store with default state (nulls).
      // Without this, zustand reads localStorage synchronously during the
      // first client render, populating currentTenantId DURING hydration —
      // which mismatches the SSR HTML (still null) and triggers React #418.
      // We rehydrate manually on the client via <TenantStoreHydrator/> in
      // providers.tsx, which runs in a useEffect AFTER the first render.
      skipHydration: true,
    }
  )
);
